<template>
  <b-modal
      id="image-editor-modal"
      centered
      :title="$t('pages.bg_remover.image_editor')"
      title-class="font-18"
      size="xl"
      @shown="createCanvas"
  >
    <loader :loading="loading">
      <b-row>
        <b-col lg="6" xl="8">
          <div
              class="table-responsive bg-white"
          >

            <h4 class="p-3 pt-4 text-center">
              <i class="fas fa-image"></i>
              {{ $t('pages.bg_remover.current_image') }}
            </h4>

            <div>
              <div id="canvasCon" class="cont">
                <canvas ref="image"></canvas>
                <canvas id="cursor"></canvas>
              </div>

              <div class="justify-content-center d-flex mt-3">

                <b-btn variant="success" block @click="downloadImg">
                  <i class="fas fa-save"></i>
                  {{ $t('pages.bg_remover.download') }}
                </b-btn>

              </div>

            </div>
          </div>
        </b-col>
        <b-col lg="6" xl="4">
          <div
              class="table-responsive bg-light"
              style="border-radius: 6px"
          >

            <h4 class="pt-4 text-center">
              <i class="mdi mdi-layers"></i>
              {{ $t('pages.bg_remover.select_background') }}
            </h4>

            <div>
              <div class="area">
                <div>
                  <h5 class="font-size-15">{{ $t('pages.bg_remover.brush') }}</h5>
                  <div class="mb-4">

                    <b-button-toolbar class="justify-content-center mb-2">
                      <b-button-group class="mx-1">
                        <b-button :variant="brushMode === 'source-out' ? 'primary' : ''"
                                  @click="setBrushMode('source-out')">
                          <i class="mdi mdi-pencil-minus-outline"></i>
                          {{ $t('pages.bg_remover.erase') }}
                        </b-button>
                        <b-button :variant="brushMode === 'destination-over' ? 'primary' : ''"
                                  @click="setBrushMode('destination-over')">
                          <i class="mdi mdi-pencil-plus-outline"></i>
                          {{ $t('pages.bg_remover.restore') }}
                        </b-button>
                      </b-button-group>
                    </b-button-toolbar>

                    <b-form-group
                        :label="$t('pages.bg_remover.size')"
                        label-for="brush-size"
                        style="margin-right: 12px !important;"
                    >
                      <b-form-input @change="handleBrushSize"
                                    :disabled="!brushMode"
                                    class="w-100"
                                    id="brush-size"
                                    type="range"
                                    min="10"
                                    max="100"
                                    step="5"/>
                    </b-form-group>

                  </div>
                </div>
                <hr>
                <div>
                  <h5 class="font-size-15">{{ $t('pages.bg_remover.blur') }}</h5>
                  <div class="mb-4">
                    <div v-for="(blur, index) in blurOptions" :key="index" class="d-inline-flex">
                      <div class="blur-img">
                        <b-img
                            @click="makeBlurredBg(blur.value)"
                            fluid
                            class="blurBtn"
                            :style="`filter: blur(${blur.blur}px;`"
                            :src="require('@/assets/images/image.png')"
                            :alt="index + '-blur'"/>
                        <div class="blur-diagonal"
                             v-if="blur.value < -1">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div>
                  <h5 class="font-size-15">{{ $t('pages.bg_remover.color') }}</h5>
                  <simplebar class="color-area">
                    <v-swatches v-model="color"
                                inline
                                class="bg-light"
                                swatch-size="46"
                                show-border
                                row-length="40"
                                :swatches="swatches"
                    />
                  </simplebar>
                </div>
              </div>
            </div>
          </div>

        </b-col>
      </b-row>
    </loader>
  </b-modal>
</template>

<script>
import simplebar from "simplebar-vue";
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import Editor from "../../../../scripts/editor"

export default {
  name: "ImageEditor",
  components: {
    simplebar,
    VSwatches
  },
  props: ['defaultImage', 'image'],
  data() {
    return {
      editor: null,
      canvas: null,
      swatches: [
        ['', '#ffffff', '#afb2b7', '#d7d8da', '#f3f3f3'],
        ["#69D2E7", "#A7DBD8", "#E0E4CC", "#F38630", "#FA6900"],
        ["#FE4365", "#FC9D9A", "#F9CDAD", "#C8C8A9", "#83AF9B"],
        ["#ECD078", "#D95B43", "#C02942", "#542437", "#53777A"],
        ["#556270", "#4ECDC4", "#C7F464", "#FF6B6B", "#C44D58"],
        ["#774F38", "#E08E79", "#F1D4AF", "#ECE5CE", "#C5E0DC"],
        ["#E8DDCB", "#CDB380", "#036564", "#033649", "#031634"],
        ["#490A3D", "#BD1550", "#E97F02", "#F8CA00", "#8A9B0F"],
        ["#594F4F", "#547980", "#45ADA8", "#9DE0AD", "#E5FCC2"],
        ["#00A0B0", "#6A4A3C", "#CC333F", "#EB6841", "#EDC951"],
        ["#E94E77", "#D68189", "#C6A49A", "#C6E5D9", "#F4EAD5"],
        ["#D9CEB2", "#948C75", "#D5DED9", "#7A6A53", "#99B2B7"],
        ["#FFFFFF", "#CBE86B", "#F2E9E1", "#1C140D", "#CBE86B"],
        ["#EFFFCD", "#DCE9BE", "#555152", "#2E2633", "#99173C"],
        ["#3FB8AF", "#7FC7AF", "#DAD8A7", "#FF9E9D", "#FF3D7F"],
        ["#343838", "#005F6B", "#008C9E", "#00B4CC", "#00DFFC"],
        ["#413E4A", "#73626E", "#B38184", "#F0B49E", "#F7E4BE"],
        ["#99B898", "#FECEA8", "#FF847C", "#E84A5F", "#2A363B"],
        ["#FF4E50", "#FC913A", "#F9D423", "#EDE574", "#E1F5C4"],
        ["#554236", "#F77825", "#D3CE3D", "#F1EFA5", "#60B99A"],
        ["#351330", "#424254", "#64908A", "#E8CAA4", "#CC2A41"],
        ["#00A8C6", "#40C0CB", "#F9F2E7", "#AEE239", "#8FBE00"],
        ["#FF4242", "#F4FAD2", "#D4EE5E", "#E1EDB9", "#F0F2EB"],
        ["#655643", "#80BCA3", "#F6F7BD", "#E6AC27", "#BF4D28"],
        ["#8C2318", "#5E8C6A", "#88A65E", "#BFB35A", "#F2C45A"],
        ["#FAD089", "#FF9C5B", "#F5634A", "#ED303C", "#3B8183"],
        ["#BCBDAC", "#CFBE27", "#F27435", "#F02475", "#3B2D38"],
        ["#D1E751", "#FFFFFF", "#000000", "#4DBCE9", "#26ADE4"],
        ["#FF9900", "#424242", "#E9E9E9", "#BCBCBC", "#3299BB"],
        ["#5D4157", "#838689", "#A8CABA", "#CAD7B2", "#EBE3AA"],
        ["#5E412F", "#FCEBB6", "#78C0A8", "#F07818", "#F0A830"],
        ["#EEE6AB", "#C5BC8E", "#696758", "#45484B", "#36393B"],
        ["#1B676B", "#519548", "#88C425", "#BEF202", "#EAFDE6"],
        ["#F8B195", "#F67280", "#C06C84", "#6C5B7B", "#355C7D"],
        ["#452632", "#91204D", "#E4844A", "#E8BF56", "#E2F7CE"],
        ["#F04155", "#FF823A", "#F2F26F", "#FFF7BD", "#95CFB7"],
        ["#F0D8A8", "#3D1C00", "#86B8B1", "#F2D694", "#FA2A00"],
        ["#2A044A", "#0B2E59", "#0D6759", "#7AB317", "#A0C55F"],
        ["#67917A", "#170409", "#B8AF03", "#CCBF82", "#E33258"],
        ["#B9D7D9", "#668284", "#2A2829", "#493736", "#7B3B3B"],
        ["#BBBB88", "#CCC68D", "#EEDD99", "#EEC290", "#EEAA88"],
        ["#A3A948", "#EDB92E", "#F85931", "#CE1836", "#00998"]
      ],
      color: null,
      brushMode: null,
      brushSize: 25,
      loading: true,
      blurOptions: [
        {
          value: -2,
          blur: 0
        },
        {
          value: -1,
          blur: 0
        },
        {
          value: 0.2,
          blur: 0.1
        },
        {
          value: 0.5,
          blur: 1.3
        },
        {
          value: 0.8,
          blur: 1.8
        }
      ]
    }
  },
  watch: {
    color(newVal) {
      this.changeBackgroundColor('background', newVal)
    }
  },
  methods: {
    handleBrushSize(e) {
      this.brushSize = e
      this.editor.setBrushSize(this.brushSize)
    },
    setBrushMode(mode) {
      if (this.brushMode === mode) {
        this.brushMode = null
        this.editor.setDrawingMode(null)
      } else {
        this.brushMode = mode
        this.editor.setDrawingMode(mode)
      }
    },
    makeBlurredBg(blur) {
      if (blur < -1) {
        this.editor.changeBackgroundColor('background', '#ffffff00')
      } else {
        this.editor.makeBlurredBg(blur)
      }
    },
    changeBackgroundColor(id, color) {
      this.editor.changeBackgroundColor(id, color)
    },
    async createImg(src) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
          resolve(img)
        }
        img.onerror = (error) => {
          reject(error)
        }
        img.crossOrigin = "Anonymous"
        img.src = src
      })
    },
    calculateCanvasContainerSize(width, height) {
      const canvasCon = document.getElementById('canvasCon')
      const maxWidth = canvasCon.clientWidth

      if (width < maxWidth) {
        canvasCon.style.height = `${height}px`
        canvasCon.style.width = `${width}px`
      } else {
        const ratio = width / maxWidth
        const newHeight = height / ratio
        canvasCon.style.height = `${newHeight}px`
        canvasCon.style.width = `${maxWidth}px`
      }
    },
    async handleEditor() {
      const maxSize = 650
      const ref = this.$refs.image;

      const img = await this.createImg(this.defaultImage)
      const mask = await this.createImg(this.image)

      let scale
      if (img.width > img.height) {
        scale = img.width > maxSize ? maxSize / img.width : 1
      } else {
        scale = img.height > maxSize ? maxSize / img.height : 1
      }

      this.calculateCanvasContainerSize(img.width * scale, img.height * scale)

      this.editor = new Editor({
        canvas: ref,
        cursor: 'cursor',
        img,
        mask,
        width: img.width * scale,
        height: img.height * scale
      })

      await this.editor.createEditor()
    },
    async createCanvas() {
      this.loading = true
      await this.handleEditor().then(() => {
        this.loading = false
      })
    },
    async downloadImg() {
      await this.editor.downloadImg()
    }
  }
}
</script>

<style scoped>
.area {
  padding: 12px;
  text-align: left;
  margin-left: 1.5em;
  height: 100% !important;
}

.color-area {
  height: 250px !important;
}

.blur-img {
  width: 46px;
  height: 46px;
  border-radius: 11px;
  background-color: rgb(255, 255, 255);
  cursor: pointer;
  margin-right: 12px;
  margin-bottom: 12px;
  display: inline-block;
  font-size: 0;
  position: relative;
  box-shadow: inset 0 0 2px rgb(0 0 0 / 75%);
}

.blur-diagonal {
  pointer-events: none;
  position: absolute;
  top: 5px;
  left: 5px;
  width: 75%;
  height: 75%;
  background: linear-gradient(to top right, transparent 0, transparent calc(50% - 2.4px), #de080a 50%, transparent calc(50% + 2.4px), transparent);
}

.blurBtn {
  border-radius: 12px;
}

.cont {
  position: relative;
  margin: 0 auto;
  text-align: center;
}

/deep/ .cont canvas, /deep/ .canvas-container {
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

#cursor {
  pointer-events: none !important;
}

canvas {
  border: 1px solid #d2d2d2;
  border-radius: 4px;
}

/deep/ .vue-swatches__container {
  background-color: rgb(248 249 250) !important;
}

</style>